import { toolsSections } from "@/lib/guides/sections-tools";
import { gta5Sections } from "@/lib/guides/sections-gta5";
import type { GuideId, GuideManifest } from "@/lib/guides/types";

export const guideManifests: Record<GuideId, GuideManifest> = {
  tools: {
    id: "tools",
    title: "Tool Guides",
    subtitle:
      "Step-by-step walkthroughs for every Workshop tool — how each one works, what it accepts, and how to get the most out of it.",
    breadcrumb: "Tool Guides",
    sections: toolsSections,
  },
  gta5: {
    id: "gta5",
    title: "GTA Knowledge",
    subtitle:
      "File formats, vehicle meta files, FiveM resource structure, EUP clothing slots, texture workflows, the 32 Siren Script, and modkit ID fixes — everything you need to work with GTA5 assets on FiveM.",
    breadcrumb: "GTA Knowledge",
    sections: gta5Sections,
  },
};

export function getGuideManifest(guideId: string): GuideManifest | null {
  if (guideId !== "tools" && guideId !== "gta5") return null;
  return guideManifests[guideId];
}
